// src/index.js
import React from "react";
import ReactDOM from "react-dom/client"; // <- note /client
import App from "./App";
import { FBRDataProvider } from "./context/FBRDataContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <FBRDataProvider>
      <App />
    </FBRDataProvider>
  </React.StrictMode>
);